import { useMemo } from "react"
import { EmailAddressSuggestion } from "@/schema"
import { ButtonBadge } from "@ui/button-badge"

import { useEmailDialog } from "@/components/email/use-email-dialog"

interface EmailBadgeWithDialogProps {
  email?: string | null
  toEmails?: EmailAddressSuggestion[] | null
  recommendedEmails?: EmailAddressSuggestion[] | null
  householdId?: string | null
}

export function EmailBadgeWithDialog({ email, toEmails, recommendedEmails, householdId }: EmailBadgeWithDialogProps) {
  const resolvedToEmails = useMemo(() => {
    if (toEmails?.length) {
      return toEmails
    }

    if (email) {
      return [{ email, name: null, type: null }] as EmailAddressSuggestion[]
    }

    return []
  }, [email, toEmails])

  const { open: openEmailDialog, canSendEmail } = useEmailDialog({
    toEmails: resolvedToEmails.length ? resolvedToEmails : null,
    recommendedEmails: recommendedEmails?.length ? recommendedEmails : null,
    householdId,
  })

  if (!email) return "-"

  return (
    <ButtonBadge
      text={email}
      copyText={email}
      onClick={
        canSendEmail
          ? (event) => {
              event.preventDefault()
              event.stopPropagation()
              openEmailDialog()
            }
          : undefined
      }
    />
  )
}
